<template>
    <div class="and-container">
        <div class="and-clause d-flex flex-column">
            <div class="d-flex row and-first-row">
                <dx-select-box
                    v-model="type"
                    :dataSource="availableTypes"
                    valueExpr="value"
                    displayExpr="displayValue"
                    :placeholder="this.$i18n.CHOOSE_RECORD_TYPE"
                    class="and-dropdown type-dropdown"
                    :searchEnabled="true"
                ></dx-select-box>

                <dx-select-box
                    v-model="field"
                    :dataSource="availableFields"
                    valueExpr="value"
                    displayExpr="displayValue"
                    :placeholder="this.$i18n.CHOOSE_RECORD_FIELD"
                    class="and-dropdown field-dropdown"
                    :searchEnabled="true"
                ></dx-select-box>

                <dx-select-box
                    v-model="operator"
                    :dataSource="[{ value: 'equals', displayValue: 'equals' }]"
                    valueExpr="value"
                    displayExpr="displayValue"
                    :placeholder="this.$i18n.CHOOSE_OPERATOR"
                    class="operator-dropdown"
                    :searchEnabled="true"
                    :disabled="true"
                ></dx-select-box>
            </div>

            <div class="d-flex row and-second-row">
                <dx-select-box
                    v-model="value"
                    :dataSource="availableValues"
                    valueExpr="value"
                    displayExpr="displayValue"
                    :placeholder="this.$i18n.CHOOSE_FIELD_VALUE"
                    class="value-dropdown"
                    :searchEnabled="true"
                ></dx-select-box>

                <span class="red-button">
                    <close-circle-outline @click="$emit('deleteMe')" :title="this.$i18n.REMOVE_FILTER_LINE" />
                </span>
            </div>

            <span class="and-indicator">{{ this.$i18n.AND }}</span>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { DxSelectBox } from "devextreme-vue/select-box";
import CloseCircleOutline from "vue-material-design-icons/CloseCircleOutline.vue";

export default {
    name: "AndClause",
    components: {
        DxSelectBox,
        CloseCircleOutline,
    },
    props: {
        module: String,
    },
    data: function () {
        return {
            type: "",
            field: "",
            operator: "equals",
            value: "",
            availableTypes: [],
            availableFields: [],
            availableValues: [],
        };
    },
    computed: {
        ...mapState("tumourDataModule", {
            tumourAttributes: (state) => state.mrAttributes,
        }),
        ...mapState("rhinoDataModule", {
            rhinoAttributes: (state) => state.mrAttributes,
        }),
        ...mapState("ciDataModule", {
            ciAttributes: (state) => state.mrAttributes,
        }),
        ...mapState("tagDataModule", {
            tagAttributes: (state) => state.mrAttributes,
        }),
        ...mapState("patientsListDataModule", {
            patientsListAttributes: (state) => state.mrAttributes,
        }),
        ...mapState({
            queryDisplayValues: (state) => state.queryDisplayValues,
        }),
        mrAttributes: function () {
            return this[`${this.module}Attributes`];
        },
    },
    watch: {
        mrAttributes: function () {
            this.updateAvailableTypes();
            this.$emit("updateTree");
        },
        type: function () {
            this.field = "";
            this.value = "";
            this.updateAvailableValues();
            this.updateAvailableFields();
            this.$emit("updateTree");
        },
        field: function () {
            this.value = "";
            this.updateAvailableValues();
            this.$emit("updateTree");
        },
        value: function () {
            this.$emit("updateTree");
        },
    },
    mounted: function () {
        this.updateAvailableTypes();
    },
    methods: {
        toTitleCase: function (str) {
            return str.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },
        updateAvailableValues: function () {
            if (!this.type || !this.field) return [];

            const values = [...this.mrAttributes[this.type][this.field]];
            let result = [];

            for (let value of values) {
                result.push({
                    value: value.value,
                    displayValue: value.displayValue,
                });
            }

            this.availableValues = result;
        },
        updateAvailableTypes: function () {
            const types = Object.keys(this.mrAttributes || {});
            let result = [];

            for (let type of types) {
                let displayValue = type.replace("ci_", "");
                displayValue = type.replace("rhino_", "");
                displayValue = displayValue.replace(/_/g, " ");

                let value = type;

                result.push({ value, displayValue: this.toTitleCase(displayValue) });
            }

            this.availableTypes = result;
            if (this.availableTypes.length === 1) {
                this.type = this.availableTypes[0].value;
            }
        },
        updateAvailableFields: function () {
            if (!this.type) return [];

            const fields = Object.keys(this.mrAttributes[this.type] || {});
            let result = [];

            for (let field of fields) {
                let displayValue = field
                    // TODO:AT - check if mismatch between prefix and type is intended or a data problem
                    .replace("comorbidities", "")
                    .replace(this.type, "")
                    .replace(/_/g, " ")
                    .replace(/-/g, " ");
                let value = field;

                result.push({ value, displayValue: this.toTitleCase(displayValue) });
            }

            this.availableFields = result;
        },
    },
};
</script>
<style scoped>
.and-clause {
    background: #f2f7f8;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
}

.and-indicator {
    padding-top: 20px;
}

.and-container:first-of-type {
    padding-top: 20px;
}

.and-container:last-of-type {
    padding-bottom: 0 !important;
}

.value-dropdown {
    width: 96%;
}

.type-dropdown {
    width: 39%;
}

.field-dropdown {
    width: 39%;
}

.operator-dropdown {
    width: 20%;
    min-width: 50px;
}

.and-first-row,
.and-second-row {
    justify-content: space-between;
    align-self: center;
    width: 100%;
}

.and-second-row {
    flex-wrap: nowrap;
}

.and-first-row {
    margin-bottom: 10px;
    height: 30px;
    flex-wrap: wrap;
}

.and-clause {
    width: 95%;
}

.mdi-close-circle {
    width: 3%;
}

.and-container:last-of-type div .and-indicator {
    display: none !important;
}

.mdi-plus-circle {
    color: #009efb;
    font-size: 20px;
}

.mdi-close-circle {
    color: palevioletred;
    font-size: 20px;
    cursor: pointer;
}

.and-dropdown {
    min-width: 220px;
}

@media only screen and (max-width: 1094px) {
    .type-dropdown,
    .field-dropdown {
        width: 48%;
        margin-bottom: 5px;
    }

    .operator-dropdown {
        width: 100%;
    }
}

@media only screen and (max-width: 966px) {
    .type-dropdown,
    .field-dropdown {
        width: 100%;
        margin-bottom: 5px;
    }

    .operator-dropdown {
        width: 100%;
    }
}
</style>
